import { Link } from "react-router-dom";
import { prepareTags } from "../utils/commonUtility";

export default function BlogItem({ blog }) {
	const { id, title, image, tags, createdAt, likes, isSaved } = blog || {};

	const tagList = prepareTags(tags);

	return (
		<div className="lws-card">
			<Link to={`blogs/${id}`}>
				<img
					src={image}
					className="lws-card-image"
					alt="blog thumbnail"
				/>
			</Link>
			<div className="p-4">
				<div className="lws-card-header">
					<p className="lws-publishedDate">{createdAt}</p>
					<p className="lws-likeCount">
						<i className="fa-regular fa-thumbs-up"></i>
						{likes}
					</p>
				</div>
				<Link to={`blogs/${id}`} className="lws-postTitle">
					{title}
				</Link>
				<div className="lws-tags">{tagList}</div>
				{isSaved && (
					<div className="flex gap-2 mt-4">
						<span className="lws-badge"> Saved </span>
					</div>
				)}
			</div>
		</div>
	);
}
